import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { UserSession } from './types'

export const initialState: UserSession = {
  authenticated: false,
  checkTimeout: false,
  error: false,
  language: '',
  user: undefined,
  wss: false
}

export const state = initialState

const namespaced = true

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
